import React from 'react';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import Info from 'material-ui/svg-icons/action/info';
import Storage from 'material-ui/svg-icons/device/storage';
import School from 'material-ui/svg-icons/social/school';
import Group from 'material-ui/svg-icons/social/group';
import Count from './parts/Counter';
import api from '../services/api';
import './Home.css';
class Home extends React.Component {
  constructor(props) {
    super(props);       
    this.handleChangeInstitution = this.handleChangeInstitution.bind(this);    
    this.state = {active: null,
                  alumni:null,
                enrollment:null,
                institution: this.props.institution};    
  }
  componentDidUpdate(prevProps, nextState) {
    
    if(this.state.institution!==nextState.institution)
      alert("alert");
  }
  handleChangeInstitution(institution) {        
      alert("alert");
  }
  componentDidMount(){    
    this.updateData();
  }
  updateData(){    
    api.getActive().then((rs) => {
        this.setState({active:rs.response});        
      })
      .catch((error) => {        
        console.error(error);
      });  
    api.getAlumni().then((rs) => {
        this.setState({alumni:rs.response});        
      })
      .catch((error) => {        
        console.error(error);
      });
    api.getEnrollment().then((rs) => {      
        this.setState({enrollment:rs.response});        
      })
      .catch((error) => {        
        console.error(error);
      });
  }
  render(){    
    var active = this.state.active;
    var alumni = this.state.alumni;
    var enrollment = this.state.enrollment;
    return (      
      <div className="home-main">
        <h1>Home</h1>
        <Count label="Alumni ativo" count={active} color="green" icon={Group} />
        <Count label="Alumni" count={alumni} color="blue" icon={Storage} />
        <Count label="Diplomas" count={enrollment} color="orange" icon={School} />        
      </div>      
    )
    }
};

export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home.js